import {AddressFieldsSchema} from '@cypro/ui/components/form/address/utils'
import {SortSchema} from '@cypro/ui/schemas'
import * as z from 'zod'

export type SectionType = 'outpatients'

export const SectionFormSchema = z.object({
  name: z.string().trim().nonempty(),
  code: z.string().trim().nonempty(),
  costCenterNumber: z.string().trim().nonempty(),
  orderNumber: z.string(),
  movementType: z.string(),
  address: AddressFieldsSchema,
})

export const SectionsFiltersSchema = z.object({
  search: z.string().optional(),
})

export const SectionsSearchSchema = z.object({
  filters: SectionsFiltersSchema.optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})

export type SectionFormSchema = z.infer<typeof SectionFormSchema>
